import { DetailedStep, StepId } from '../types';
import {
  DescriptionStep,
  PreparationStep,
  DemolitionStep,
  GrosOeuvreStep,
  VRDStep,
  IsolationStep,
  CloisonsStep,
  TechnicalStep,
  SanitaireStep,
  RevetementsStep,
  MenuiserieStep,
  FinitionsStep,
  ExterieursStep,
  ResultStep
} from '../steps';

export const DETAILED_STEPS: DetailedStep[] = [
  {
    id: 'description',
    title: 'Description du bien',
    description: 'Où et quoi ?',
    component: DescriptionStep
  },
  {
    id: 'preparation',
    title: 'Préparation & Études',
    description: 'Bien démarrer',
    component: PreparationStep
  },
  {
    id: 'demolition',
    title: 'Démolition',
    description: 'Faire place nette',
    component: DemolitionStep
  },
  {
    id: 'gros-oeuvre',
    title: 'Gros œuvre',
    description: 'Restructurer',
    component: GrosOeuvreStep
  },
  {
    id: 'vrd',
    title: 'VRD',
    description: 'Alimenter',
    component: VRDStep
  },
  {
    id: 'isolation',
    title: 'Isolation et Étanchéité',
    description: 'Isoler',
    component: IsolationStep
  },
  {
    id: 'cloisons',
    title: 'Cloisons & Aménagement',
    description: 'Aménager',
    component: CloisonsStep
  },
  {
    id: 'technique',
    title: 'Electricité, etc.',
    description: 'Rendre fonctionnel',
    component: TechnicalStep
  },
  {
    id: 'sanitaire',
    title: 'Sanitaire et hygiène',
    description: 'Se laver',
    component: SanitaireStep
  },
  {
    id: 'revetements',
    title: 'Revêtements',
    description: 'Recouvrir les surfaces',
    component: RevetementsStep
  },
  {
    id: 'menuiserie',
    title: 'Menuiseries',
    description: 'Portes et fenêtres',
    component: MenuiserieStep
  },
  {
    id: 'finitions',
    title: 'Finitions',
    description: 'Décorer',
    component: FinitionsStep
  },
  {
    id: 'exterieurs',
    title: 'Extérieurs',
    description: 'Autour du bien',
    component: ExterieursStep
  },
  {
    id: 'resultat',
    title: 'Résultat',
    description: 'Combien ça coûte ?',
    component: ResultStep
  }
];

export const getNextStep = (currentStepId: StepId): StepId | null => {
  const currentIndex = DETAILED_STEPS.findIndex(step => step.id === currentStepId);
  if (currentIndex < DETAILED_STEPS.length - 1) {
    return DETAILED_STEPS[currentIndex + 1].id;
  }
  return null;
};

export const getPreviousStep = (currentStepId: StepId): StepId | null => {
  const currentIndex = DETAILED_STEPS.findIndex(step => step.id === currentStepId);
  if (currentIndex > 0) {
    return DETAILED_STEPS[currentIndex - 1].id;
  }
  return null;
};

export type { StepId } from '../types/steps';